module.exports = __webpack_public_path__ + "media/images/actor_ogp_image/now_on_sale-1f8abf2305dc1d7ea87e6a12a693b415.png";